import { encrypt, generateHMAC } from "../../Utils/hmac";
import { API_HOST } from "../BaseUrl";
import client, { headers } from "./config";
import api from "./sessionExpiryAxios";

const SUBSCRIPTION_STATUS_TIMEOUT_MS = 15000;

export const postLogDetails = async (data) => {
    const hmac = await generateHMAC()
    const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }

    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `ping`, { _n }, { headers: updatedHeaders });
            if (response.status === 200) {
                resolve(response);
            }
            reject(response);

        } catch (error) {
            reject(error);
        }
    });
};

/**
 * Fetch the current clinic's raw status + Stripe subscription status.
 * @returns {Promise} Response with `data: { status, subscription_status }` — `subscription_status` is `"none"` when the clinic has no Stripe account yet.
 */
export const getClinicSubscriptionStatus = async () => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }

    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.get(API_HOST + `claraview/clinics/subscription-status`, { headers: updatedHeaders, timeout: SUBSCRIPTION_STATUS_TIMEOUT_MS });
            if (response.status === 200) {
                resolve(response);
            }
            reject(response);
        } catch (error) {
            reject(error);
        }
    });
};

export const getTpScanAppDetails = async ({ c }) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.get(API_HOST + `tp-app/${c}`, { headers: updatedHeaders });
            if (response.status === 200) {
                resolve(response);
            }
            reject(response);
        } catch (error) {
            reject(error);
        }
    });
};
